import { render, staticRenderFns } from "./CategoryBox.vue?vue&type=template&id=797e3d5a"
import script from "./CategoryBox.vue?vue&type=script&lang=ts"
export * from "./CategoryBox.vue?vue&type=script&lang=ts"
import style0 from "./CategoryBox.vue?vue&type=style&index=0&id=797e3d5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports